module.exports = __webpack_public_path__ + "img/contact_a04.51b01a48.png";